import * as actions from '../../actions/coreActions';
import { buildReducer } from '../../../shared';
import type { UserConfiguration } from '../../state/data/UserConfiguration';

// Task 208924: Investigate how to keep this copies of userConfig in sync
export default buildReducer<UserConfiguration>()
    .handle(actions.userConfigurationReceivedAction, (state, action) => {
        const userConfig = action.payload.userConfig;
        return {
            ...state,
            userOptions: userConfig && { ...userConfig.UserOptions },
            settings: userConfig && { ...userConfig.SessionSettings },
            RecoverDeletedItemsEnabled: userConfig?.RecoverDeletedItemsEnabled,
        };
    })
    .done({
        settings: null,
        userOptions: null,
        RecoverDeletedItemsEnabled: false,
    });
export type { Action } from '../../../shared';
